import React, { useState } from 'react';
import { DialogActions, Button } from '@material-ui/core';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { useFormikContext } from 'formik';
import LoadingButton from '~/modules/common/components/LoadingButton';
import { useOnSubmitHandler } from './hooks';

export const ChangeTaskResourceDialogFooter = ({
  isNewUserInfoLoading,
  onClose,
  onChangeTaskResourceSuccess,
  resourceEstimate,
  task
}) => {
  const [isSaving, setIsSaving] = useState(false);

  const {
    values: { allocationMode, newResourceUser, availableHours }
  } = useFormikContext();

  const { onSubmit } = useOnSubmitHandler({
    newResourceUser,
    onClose,
    onChangeTaskResourceSuccess,
    existingResourceUserId: resourceEstimate.resourceUser.id,
    setIsSaving,
    taskId: task.id,
    projectId: task.projectReference.id,
    allocationMode,
    availableHours,
    taskAllocationHours:
      resourceEstimate?.taskResourceUserAllocation?.totalHours
  });

  return (
    <DialogActions>
      <Button onClick={onClose}>
        <FormattedMessage id="changeTaskResourceDialog.cancel" />
      </Button>
      <LoadingButton
        color="primary"
        onClick={onSubmit}
        isLoading={isSaving}
        disabled={Boolean(!newResourceUser) || isNewUserInfoLoading}
      >
        <FormattedMessage id="changeTaskResourceDialog.changeTaskResource" />
      </LoadingButton>
    </DialogActions>
  );
};

ChangeTaskResourceDialogFooter.propTypes = {
  isNewUserInfoLoading: PropTypes.bool,
  onClose: PropTypes.func,
  onChangeTaskResourceSuccess: PropTypes.func,
  resourceEstimate: PropTypes.object,
  task: PropTypes.object
};

export default ChangeTaskResourceDialogFooter;
